
import { defineComponent } from 'vue'

import {
  regExDigit,
  regExLowercase,
  regExMinLength,
  regExUppercase,
} from '@/app/regularExpressions'

import CheckIcon from '@C/ui/icons/CheckIcon.vue'
import CloseIcon from '@C/ui/icons/CloseIcon.vue'
import InputTip from '@C/ui/popover/InputTip.vue'

export default defineComponent({
  name: 'PasswordValidationTip',
  components: { InputTip, CloseIcon, CheckIcon },
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  computed: {
    validations() {
      return [
        {
          id: 1,
          title: 'at least 8 characters',
          isValid: this.checkPassword(regExMinLength),
        },
        {
          id: 2,
          title: '1 number',
          isValid: this.checkPassword(regExDigit),
        },
        {
          id: 3,
          title: '1 uppercase',
          isValid: this.checkPassword(regExUppercase),
        },
        {
          id: 4,
          title: '1 lowercase',
          isValid: this.checkPassword(regExLowercase),
        },
      ]
    },
  },
  methods: {
    checkPassword(regEx: RegExp) {
      return !!this.password.match(regEx)
    },
  },
})
